// Sidebar.js
import React, {useEffect, useState} from "react";
import "./Sidebar.scss";
import busIcon from '../../../assets/img/bus-icon.svg'
import { getStops } from "./Sidebar.service";


interface IStops {
    nombre: string,
    hora_programada: string,
    hora_registro: string,
    hora_estimada: string,
}

// @ts-ignore
const Sidebar = ({ idTrazo, idBitacora }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [stops, setStops] = useState<IStops[] | []>([]);

    useEffect(() => {
        if(idTrazo) {
            const fetchStops = async () => {

                getStops(setStops, idTrazo, idBitacora);
            }
            fetchStops();
            const interval = setInterval(fetchStops, 120000);
            return () => clearInterval(interval);
        }
    }, [idBitacora, idTrazo]);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const Left = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="16" viewBox="0 0 6 16">
            <path fillRule="evenodd" d="M6 2L0 8l6 6V2z" fill="white"/>
        </svg>
    )

    const Right = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="16" viewBox="0 0 6 16">
            <path fillRule="evenodd" d="M0 14l6-6-6-6v12z" fill="white"/>
        </svg>
    )

    return (
        <div className="sidebar-container">
            <div className={`sidebar ${isOpen ? "open" : ""}`}>
                <div className="sidebar-content">
                <div className="timeline">
                    { stops.length > 0  && stops.map((item, index) => (
                        <div key={index} className="timeline-item">
                            <div className="timeline-marker"
                                 style={{backgroundColor: item.hora_registro ? '#63C4A5' :'#fff'}}>
                                <img src={busIcon} alt="bus-icon"/>
                            </div>
                            <div className="flecha"></div>
                            <div className="timeline-content">
                                <h3>{item.nombre}</h3>
                                <p>Hora Programada: {item.hora_programada}</p>
                                <span>Hora Registro: {item.hora_registro}</span><br/>
                                {item.hora_registro === null && (
                                    <span>Hora Estimada: {item.hora_estimada}</span>)
                                }
                            </div>
                        </div>
                    ))}
                </div>
                </div>
            </div>
            <button className={`toggle-btn ${isOpen ? "open" : ""}`} onClick={toggleSidebar}>
                {isOpen ? <Right /> : <Left />}
            </button>
        </div>
    );
};

export default Sidebar;
